import {useDispatch} from 'react-redux';
import * as React from 'react';
import {useEffect} from 'react';
import {Route} from '@react-navigation/native';
import {getPollDetails, setPollDetails} from '../../redux/actions/polls/details';
type ResolverProps = {route: Route<string, {pollId?: string}>};

export const PollDetailsResolver = (viewComponent: React.FC<ResolverProps>) => {
  return function Resolver(props: ResolverProps) {
    const dispatch = useDispatch();
    const pollId = props.route.params?.pollId;

    useEffect(() => {
      if (pollId) {
        dispatch(getPollDetails(+pollId));
      } else {
        dispatch(setPollDetails(null));
      }

      return () => {
        dispatch(setPollDetails(null));
      };
    }, [pollId]);

    return React.createElement(viewComponent, props);
  };
};
